import environment from '@/environment';
import {type SupportedLocale} from '@/initializers/i18next';

export const getDefaultLocale = (
  supportedLocales: SupportedLocale[],
  fallbackLocale: SupportedLocale,
): SupportedLocale => {
  const localizedUrls = {
    [environment.URL_EN]: 'en',
    [environment.URL_FR]: 'fr',
    [environment.URL_INT]: 'fr',
  };

  if (window.origin in localizedUrls) {
    return localizedUrls[window.origin] as SupportedLocale;
  }

  const navigatorLocale = navigator.language;
  const [baseLocale] = navigatorLocale.split('-');

  return supportedLocales.includes(baseLocale as SupportedLocale) ? (baseLocale as SupportedLocale) : fallbackLocale;
};
